import { StatusType } from '@app/api-module/control-centre-api-client';
import { BadgeClass } from './css-badge-classes';

export const OrderStatusClassMapping = new Map<StatusType, BadgeClass>([
    [StatusType.OnHoldMissingClinicalHistory, BadgeClass.MissingClinicalHistory],
    [StatusType.OnHoldMissingDocumentation, BadgeClass.MissingDocumentation],
    [StatusType.OnHoldMissingImages, BadgeClass.MissingImages],
    [StatusType.OnHoldMissingPriors, BadgeClass.MissingPriorReport],
    [StatusType.OnHoldReviewOrderDetails, BadgeClass.ReviewOrderDetails],
    [StatusType.OnHoldMissingPriorImages, BadgeClass.MissingPriorImages],
    [StatusType.AwaitingFurtherDetails, BadgeClass.AwaitingFurtherDetails],
    [StatusType.AwaitingImages, BadgeClass.TransferringImages],
    [StatusType.TransferringImages, BadgeClass.TransferringImages],
    [StatusType.ReadyToReport, BadgeClass.ReadyToReport],
    [StatusType.Reporting, BadgeClass.Reporting],
    [StatusType.Reported, BadgeClass.Reported],
    [StatusType.Cancelled, BadgeClass.Cancelled]
]);
